module.exports = __webpack_public_path__ + "static/media/007.63e4e5fe.jpg";